<script>
import store from '@state/store'
import { debounce } from 'debounce'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'SendPointsModal',
  components: {
    VueTagsInput,
  },
  props: {
    points: { type: Number, required: true },
    showModal: { type: Boolean, required: true },
  },
  data() {
    return {
      quantity: null,
      quantityFlag: false,

      userTag: '',
      userTags: [],
      userDisplayTags: [],

      confirmationFlag: false,
    }
  },
  watch: {
    userTag: 'searchFriends',
  },
  methods: {
    updateUserTags(newTags) {
      this.userDisplayTags = []
      this.userTags = newTags
    },
    getUserId() {
      return this.userTags[0].id
    },
    searchFriends: debounce(async function searchFriends() {
      if (this.userTag.length < 1) return
      store
        .dispatch('kyndPoints/searchFriends', {
          userTag: this.userTag,
        })
        .then((data) => {
          if (data instanceof Array && data.length) {
            data.slice(0, 15)
            const userDisplayTags = data.map((item) => {
              const { id, name } = item
              return { id, text: name }
            })
            this.userDisplayTags = userDisplayTags
          }
        })
    }, 500),
    setConfirmationFlag() {
      this.confirmationFlag = true
    },
    sendGift() {
      if (!this.userTags || !this.quantity || this.quantityFlag) {
        return
      }
      const params = {
        quantity: this.quantity,
        user_id: this.getUserId(),
      }
      store
        .dispatch('kyndPoints/sendGift', params)
        .then((response) => {
          this.closeModal()
          alert('Sent successfully!')
        })
        .catch((err) => alert(err.message || 'Something went wrong.'))
    },
    closeModal() {
      this.confirmationFlag = false
      this.quantity = null
      this.userTag = ''
      this.userTags = []
      this.userDisplayTags = []

      this.$emit('close-modal')
    },
    quantityValidation() {
      if (this.quantity <= 0) {
        this.quantityFlag = true
      } else {
        this.quantityFlag = false
      }
    },
  },
}
</script>

<template>
  <BaseModalWindow
    v-if="showModal"
    modalcls="w-user-edit bg-white rounded-xl mx-10 px-11 shadow-box relative left-0 flex justify-between overflow-hidden"
    :visible="showModal"
    @close="closeModal"
  >
    <template v-slot:body>
      <div v-if="confirmationFlag" class="w-full mx-auto mt-4 mb-6">
        <div
          class="flex justify-between items-center border-b border-gray pt-4 pb-4 mb-6"
        >
          <h3 class="text-2xl text-blue-darker">Confirmation</h3>
        </div>
        <div>
          Please confirm that you want to send
          <span class="font-bold text-blue-light">{{ quantity }}</span> Kynd
          Points to
          <span class="font-bold text-blue-light">{{ userTags[0].text }}</span
          >.
        </div>
        <p>This cannot be undone.</p>
        <div class="flex justify-center mt-12">
          <button
            class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5"
            @click="sendGift"
          >
            Confirm
          </button>
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5 ml-2"
            @click="closeModal"
          >
            Cancel
          </button>
        </div>
      </div>
      <div v-else class="w-full mx-auto mt-12 mb-6">
        <div
          class="flex justify-between items-center border-b border-gray pt-4 pb-4 mb-6"
        >
          <h3 class="text-2xl text-blue-darker">Send Points</h3>
          <span>
            Your Balance:
            <span class="text-blue-darker font-bold">{{ points }}</span>
          </span>
        </div>

        <div class="flex">
          Send
          <input
            v-model="quantity"
            name="quantity"
            type="number"
            placeholder="quantity"
            class="border-b border-gray w-22 mx-2 pl-3 text-center"
            @input="quantityValidation"
          />
          points to:
        </div>
        <div v-if="quantityFlag" class="mt-2 text-sm errors text-volunteer_red">
          Sorry, quantity only could be positive number.
        </div>

        <div class="mt-8">
          <VueTagsInput
            v-model="userTag"
            :tags="userTags"
            :max-tags="1"
            :maxlength="userTags.length ? 0 : 10"
            :autocomplete-items="userDisplayTags"
            :add-only-from-autocomplete="true"
            :add-on-blur="false"
            placeholder="Search for friends"
            @tags-changed="updateUserTags"
          />
        </div>

        <div class="flex justify-center mt-12">
          <button
            :class="[
              'button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5',
              quantity && userTags.length ? '' : 'opacity-50',
            ]"
            :disabled="
              quantity && !quantityFlag && userTags.length ? false : true
            "
            @click="setConfirmationFlag"
          >
            Send
          </button>
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5 ml-2"
            @click="closeModal"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </BaseModalWindow>
</template>
